module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/sakae_point4-00fcba4b1f7c62ff91bc38ce1070848e.jpg";